import { render, staticRenderFns } from "./EventTotalSection.vue?vue&type=template&id=0419c133&scoped=true"
import script from "./EventTotalSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventTotalSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventTotalSection.vue?vue&type=style&index=0&id=0419c133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419c133",
  null
  
)

export default component.exports